module.exports = __webpack_public_path__ + "static/media/5.f0b8b253.jpg";